import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerComponent } from './components/drawer/drawer.component';
import { DrawerModule } from 'primeng/drawer';
import { SharedUiButtonsModule } from '@shared/ui/buttons';

@NgModule({
  imports: [CommonModule, DrawerModule, SharedUiButtonsModule],
  declarations: [DrawerComponent],
  exports: [DrawerComponent],
})
export class SharedUiDrawerModule {}
